/**
 * @ngdoc Service
 */
(function() {
    'use strict';

    angular.module('vrm.core')
        .service('ResetTwoFactorService', ResetTwoFactorService);

    /**
     * @constructor
     * @ngInject
     */
    function ResetTwoFactorService(ApiService, vrmNotificationsService, vrmNotificationType) {

        /* Public API */
        var service = {
            requestModel: {
                email: null,
            },
            verifyModel: {
                email: null,
                password: null,
                two_factor_reset_hash: null,
            },
            resetTwoFactorRequest: resetTwoFactorRequest,
            verifyTwoFactorResetRequest: verifyTwoFactorResetRequest,
        };

        return service;

        /* Private */

        /**
         * Request a 2fa reset
         */
        function resetTwoFactorRequest() {

            return ApiService
                .call('/auth/resettwofactor', service.requestModel)
                .then(function(response) {
                    if (response.data.success) {
                        return true;
                    } else {
                        vrmNotificationsService.add({ type: vrmNotificationType.DANGER, message: ApiService.formatErrors(response) + ' (1512)'}, true);
                        return false;
                    }
                })
        }

        /**
         * Verify a 2fa reset
         */
        function verifyTwoFactorResetRequest() {
            return ApiService.auth("/verifytwofactorreset", service.verifyModel)
                .then(function(response) {
                    // If we received a token from the API, redirect us
                    if (ApiService.isLoggedIn())
                    {
                        return true;
                    } else {
                        vrmNotificationsService.add({ type: vrmNotificationType.DANGER, message: ApiService.formatErrors(response) + " (1512)"}, true);
                        return false;
                    }
            });
        }

    }
})();
